
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.Tags = {

  template: () => {
      return {
          tag: 'div',
          items: [
            {
              attributes: {
                  class: 'tagscheck',
              },
            },
          ],
          attributes: {
              class: 'controls',
          },
      };
  },

  assignParameter(jsonParam) {
    const lookupListTag = new Monet.UI.Fields.PowerLookupList();
    lookupListTag.setId('tagLabel');
    lookupListTag.setNameSpace('EventLookupTag');
    lookupListTag.setLookUpEntity('Tag');
    lookupListTag.setDisplayKey('description');
    lookupListTag.createBaseStructure();
    const labelText = Monet.I18n.getResourcesByKey('Event.Tag.description');
    lookupListTag.setTextLabel(labelText);

    const control = document.querySelector('#Event .box-content .tagscheck');
    control.innerHTML = '';
    control.appendChild(lookupListTag.render());

    lookupListTag.postRender();

    const removeOptionsFromField = (field) => {
      if(!field) return;

      field.addPostRender(() => {
        const fieldsToRemove = ["GEOFENCE", "ROUTE"];
  
        Array.from(field.input.options).forEach((option) => {
          if (fieldsToRemove.includes(option.value)) {
            option.remove();
          }
        });
      });
    };

    const configureFilters = (lookupListTag) => {
      const field = lookupListTag.filter.fields['tagType'];
      removeOptionsFromField(field);
    }

    lookupListTag.setAfterCreateFilter(() => {
      lookupListTag.filter.setAfterAddSelectedFilter(() => {
        configureFilters(lookupListTag);
      });
    });

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      const tags = jsonParam.tagIds;
      getTagsDetails(tags);
    }

    function getTagsDetails(tagIds) {
      if (tagIds && tagIds.length) {
        const body = function () {
          return JSON.stringify({ criteriaChain: [{ and: [{ attr: 'id', in: tagIds }] }] });
        };

        const ajax = new Monet.Ajax();
        ajax.url = 'Tag/restrictions?criteria={"filters":["id","description"]}';
        ajax.data = body();
        ajax.method = 'POST';
        ajax.success = (function (scope, lookupListTag) {
          return function (data) {
            if (data) {
              lookupListTag.setValue(data);
            }
          };
        }(this, lookupListTag));

        ajax.error = function (xhr) {
          Monet.Configurations.errorNotification(null, xhr, null, null);
        };

        ajax.send();
      }
    }
  },

  retrieveParameter() {
    const values = App.Forms.EventLookupTag.lookupElement.getValue();
    const tagIds = [];

    for (let i = 0, length = values.length; i < length; i++) {
      tagIds.push(values[i].id);
    }

    return JSON.stringify({ tagIds });
  },

};
